<template>
  <div class="ak-hero">

    <!-- Atmosphere radial overlays -->
    <div class="ak-atmo"></div>

    <!-- Two spotlight beams -->
    <div class="ak-spots" :class="{ on: live }">
      <div class="ak-spot ak-spot-a"></div>
      <div class="ak-spot ak-spot-b"></div>
    </div>

    <!-- Grid lines (vertical + horizontal) -->
    <div class="ak-grid" :class="{ on: live }">
      <div class="ak-vl" style="left:calc(50% - 185px)"></div>
      <div class="ak-vl" style="left:calc(50% + 185px)"></div>
      <div class="ak-vl ak-vl-dim" style="left:calc(50% - 256px)"></div>
      <div class="ak-vl ak-vl-dim" style="left:calc(50% + 256px)"></div>
      <div class="ak-hl" style="top:172px"></div>
      <div class="ak-hl" style="top:496px"></div>
    </div>

    <!-- Page -->
    <div class="ak-page">

      <!-- Nav -->
      <nav class="ak-nav" :class="{ on: live }">
        <span class="ak-wos">WorkOS</span>
        <div class="ak-icon">
          <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
            <circle cx="16" cy="16" r="3" fill="rgba(186,214,247,.6)"/>
            <circle cx="16" cy="16" r="8" stroke="rgba(186,214,247,.3)" stroke-width="1.2"/>
            <circle cx="16" cy="16" r="13" stroke="rgba(186,214,247,.15)" stroke-width="1" stroke-dasharray="2.5 3.5"/>
          </svg>
        </div>
        <div class="ak-actions">
          <button class="ak-gh">
            <svg width="14" height="14" viewBox="0 0 16 16" fill="rgba(186,214,247,.7)">
              <path fill-rule="evenodd" d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.013 8.013 0 0016 8c0-4.42-3.58-8-8-8z"/>
            </svg>
          </button>
          <button class="ak-start">Get started</button>
        </div>
      </nav>

      <!-- "Introducing" label with side lines -->
      <div class="ak-badge" :class="{ on: live }">
        <span class="ak-badge-text">Introducing</span>
      </div>

      <!-- AuthKit title with dotted corner box -->
      <div class="ak-title-wrap" :class="{ on: live }">
        <div class="ak-dotbox">
          <h1 class="ak-h1">AuthKit</h1>
        </div>
      </div>

      <!-- Subtitle -->
      <p class="ak-desc" :class="{ on: live }">
        The world's best login box,<br>powered by WorkOS + Radix.
      </p>

      <!-- 3 floating cards -->
      <div class="ak-cards" :class="{ on: live }">

        <!-- Left card: Blamer -->
        <div class="ak-card ak-cl">
          <div class="ak-cdots"></div>
          <div class="ak-cborder"></div>
          <div class="ak-cp">
            <div class="ak-clogo" style="background:#EF6643;border-radius:4px">
              <svg width="14" height="14" viewBox="0 0 14 14" fill="white"><polygon points="7,1 13,12 1,12"/></svg>
            </div>
            <p class="ak-cname">Welcome to Blamer</p>
            <p class="ak-csub">Log in to continue to Blamer.</p>
            <p class="ak-clabel">Email</p>
            <div class="ak-cfield">
              <span class="ak-cfield-val">your@email.com</span>
              <span class="ak-ctag" style="color:#EF6643;background:rgba(239,102,67,.12)">Primary</span>
            </div>
            <button class="ak-cta" style="background:#EF6643;border-radius:4px">Continue</button>
          </div>
        </div>

        <!-- Center card: SuperApp (animated border) -->
        <div class="ak-card ak-cc">
          <div class="ak-cdots"></div>
          <div class="ak-cring"></div>
          <div class="ak-cp">
            <div class="ak-clogo ak-clogo-ring">
              <svg width="26" height="26" viewBox="0 0 26 26" fill="none">
                <circle cx="13" cy="13" r="10" stroke="rgba(186,214,247,.35)" stroke-width="1.5"/>
                <circle cx="13" cy="13" r="5.5" stroke="rgba(186,214,247,.6)" stroke-width="1.5"/>
                <circle cx="13" cy="13" r="1.5" fill="rgba(186,214,247,.9)"/>
              </svg>
            </div>
            <p class="ak-cname">Sign in to SuperApp</p>
            <p class="ak-clabel">Email</p>
            <div class="ak-cfield">
              <span class="ak-cfield-val ak-placeholder">Your email address</span>
            </div>
            <button class="ak-cta ak-cta-pill">Continue</button>
          </div>
        </div>

        <!-- Right card: Clamer -->
        <div class="ak-card ak-cr">
          <div class="ak-cdots"></div>
          <div class="ak-cborder"></div>
          <div class="ak-cp">
            <div class="ak-clogo" style="background:rgba(255,255,255,.88);border-radius:2px;color:#111;font-size:11px;font-weight:700;font-family:system-ui">C</div>
            <p class="ak-cname">Sign in to Clamer</p>
            <p class="ak-csub">Enter a temporary passcode from your authenticator app.</p>
            <div class="ak-cfield ak-cfield-otp">
              <span>• &thinsp; • &thinsp; • &thinsp; • &thinsp; • &thinsp; •</span>
            </div>
            <button class="ak-cta" style="background:rgba(186,207,247,.05);border-radius:2px;box-shadow:inset 0 0 0 1px rgba(186,207,247,.12)">Continue</button>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AuthKitHero',
  data() {
    return { live: false };
  },
  mounted() {
    requestAnimationFrame(() => setTimeout(() => { this.live = true; }, 80));
  }
};
</script>

<style>
@property --ak-angle {
  syntax: '<angle>';
  initial-value: 0deg;
  inherits: false;
}
</style>

<style scoped>
*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

/* ── HERO ── */
.ak-hero {
  position: relative;
  background: #05060f;
  min-height: 900px;
  overflow: hidden;
  font-family: 'Geist', 'Inter', system-ui, sans-serif;
  -webkit-font-smoothing: antialiased;
}

/* ── ATMOSPHERE ── */
.ak-atmo {
  position: absolute;
  inset: 0;
  pointer-events: none;
  background-image:
    radial-gradient(50% 64% at 50% 36%, rgba(21,61,204,.08) 14%, transparent 100%),
    radial-gradient(50% 68% at 50% 32%, rgba(216,236,248,.04) 0%, rgba(152,192,239,.02) 50%, transparent 100%);
}

/* ── SPOTLIGHTS ── */
.ak-spots {
  position: absolute;
  top: 0; left: 50%;
  transform: translateX(-50%);
  width: 200px;
  height: 640px;
  opacity: 0;
  transition: opacity 1.5s .5s;
  mask-image: radial-gradient(farthest-side at 50% 0, #fff 50%, transparent 90%);
  -webkit-mask-image: radial-gradient(farthest-side at 50% 0, #fff 50%, transparent 90%);
  pointer-events: none;
}
.ak-spots.on { opacity: 1; }

.ak-spot {
  position: absolute;
  top: 60px; left: 0;
  width: 200px; height: 640px;
  border-radius: 9999px;
  filter: blur(15px);
  transform-origin: 50% 0;
}
.ak-spot-a {
  background: conic-gradient(at 50% -5%, transparent 45%, rgba(124,145,182,.3) 49%, rgba(124,145,182,.5) 50%, rgba(124,145,182,.3) 51%, transparent 55%);
  transform: rotate(18deg);
  animation: spot-pulse 5s ease-in-out infinite alternate;
}
.ak-spot-b {
  background: conic-gradient(at 50% -5%, transparent 44%, rgba(124,145,182,.25) 49%, rgba(124,145,182,.45) 50%, rgba(124,145,182,.25) 51%, transparent 56%);
  transform: rotate(0deg) scale(1.02);
  animation: spot-pulse 8s ease-in-out infinite alternate-reverse;
}
@keyframes spot-pulse {
  from { opacity: .4; transform: rotate(var(--r, 0deg)) scale(1); }
  to   { opacity: .65; transform: rotate(var(--r, 0deg)) scale(1.08); }
}
.ak-spot-a { --r: 18deg; }
.ak-spot-b { --r: 0deg; }

/* ── GRID LINES ── */
.ak-grid {
  position: absolute;
  inset: 0;
  pointer-events: none;
  opacity: 0;
  transition: opacity 3s .3s;
}
.ak-grid.on { opacity: 1; }

.ak-vl {
  position: absolute;
  top: 0; bottom: 0;
  left: var(--x, 50%);
  width: 1px;
  background: linear-gradient(180deg, rgba(186,215,247,.12) 75%, transparent);
}
.ak-vl-dim { opacity: .5; }

.ak-hl {
  position: absolute;
  left: 0; right: 0;
  top: var(--y, 0);
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(186,215,247,.12) 30%, rgba(186,215,247,.12) 70%, transparent);
}

/* ── PAGE ── */
.ak-page {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* ── NAV ── */
.ak-nav {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  height: 84px;
  padding: 0 32px;
  opacity: 0;
  transition: opacity 1.5s .3s;
}
.ak-nav.on { opacity: 1; }

.ak-wos {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: .1em;
  text-transform: uppercase;
  color: rgba(186,214,247,.4);
}
.ak-icon { display: flex; justify-content: center; }
.ak-actions { display: flex; align-items: center; justify-content: flex-end; gap: 8px; }

.ak-gh {
  width: 34px; height: 34px;
  border-radius: 999px;
  background: rgba(186,214,247,.05);
  box-shadow: inset 0 0 0 1px rgba(186,215,247,.12);
  border: none; cursor: pointer;
  display: flex; align-items: center; justify-content: center;
  backdrop-filter: blur(4px);
  transition: background .15s;
}
.ak-gh:hover { background: rgba(186,214,247,.1); }

.ak-start {
  height: 34px;
  padding: 0 16px;
  border-radius: 999px;
  background: rgba(186,214,247,.06);
  box-shadow: inset 0 0 0 1px rgba(186,215,247,.14);
  border: none; cursor: pointer;
  font-family: inherit;
  font-size: 13px;
  font-weight: 500;
  color: rgba(200,212,234,.9);
  backdrop-filter: blur(4px);
  transition: background .15s;
}
.ak-start:hover { background: rgba(186,214,247,.12); }

/* ── INTRODUCING BADGE ── */
.ak-badge {
  display: flex;
  align-items: center;
  gap: 24px;
  margin-top: 32px;
  opacity: 0;
  transform: translateY(-5px);
  transition: opacity 1.5s .3s, transform 1.5s .3s;
}
.ak-badge.on { opacity: 1; transform: translateY(0); }

.ak-badge::before,
.ak-badge::after {
  content: '';
  width: 86px;
  height: 1px;
}
.ak-badge::before {
  background: linear-gradient(90deg, transparent, rgba(184,216,254,.32));
}
.ak-badge::after {
  background: linear-gradient(270deg, transparent, rgba(184,216,254,.32));
}

.ak-badge-text {
  font-size: 14px;
  font-weight: 400;
  background: linear-gradient(0deg, #d8ecf8 0%, #98c0ef 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* ── AUTHKIT TITLE ── */
.ak-title-wrap {
  margin-top: 20px;
  opacity: 0;
  transition: opacity 2s .1s;
}
.ak-title-wrap.on { opacity: 1; }

.ak-dotbox {
  position: relative;
  padding: 6px 20px 10px;
  box-shadow: inset 0 0 0 1px rgba(186,215,247,.1);
}
.ak-dotbox::before {
  content: '';
  position: absolute;
  inset: -2px;
  pointer-events: none;
  background-image:
    radial-gradient(#d1e4fa 50%, transparent 50%),
    radial-gradient(#d1e4fa 50%, transparent 50%),
    radial-gradient(#d1e4fa 50%, transparent 50%),
    radial-gradient(#d1e4fa 50%, transparent 50%);
  background-size: 4px 4px;
  background-position: 0 0, 100% 0, 0 100%, 100% 100%;
  background-repeat: no-repeat;
  filter: drop-shadow(0 0 8px rgba(209,228,250,.9));
}

.ak-h1 {
  font-size: clamp(72px, 13vw, 148px);
  font-weight: 900;
  letter-spacing: -0.045em;
  line-height: 1;
  background: linear-gradient(180deg, #e8f4ff 0%, #bdd5f4 45%, #8db5e8 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* ── SUBTITLE ── */
.ak-desc {
  margin-top: 24px;
  font-size: 20px;
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: -0.01em;
  text-align: center;
  background: linear-gradient(0deg, #d8ecf8 0%, #98c0ef 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  opacity: 0;
  transform: translateY(10px);
  transition: opacity 1.5s .6s, transform 1.5s .6s;
}
.ak-desc.on { opacity: 1; transform: translateY(0); }

/* ── CARDS ── */
.ak-cards {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  margin-top: 48px;
  padding-bottom: 48px;
}

.ak-card {
  position: relative;
  width: 224px;
  border-radius: 16px;
  background-color: rgba(5,6,15,.97);
  background-image: linear-gradient(rgba(186,207,247,.04) 0%, rgba(186,207,247,.04) 100%);
  box-shadow:
    inset 0 1px 1px rgba(216,236,248,.2),
    inset 0 24px 48px rgba(168,216,245,.06),
    0 20px 48px rgba(0,0,0,.45);
  flex-shrink: 0;
  transition: transform 1.5s cubic-bezier(.2,0,.2,1), opacity 1.5s cubic-bezier(.2,0,.2,1);
}

/* Corner dots (shared) */
.ak-cdots {
  position: absolute;
  inset: 14px;
  pointer-events: none;
  z-index: 3;
  background-image:
    radial-gradient(#d1e4fa 50%, transparent 50%),
    radial-gradient(#d1e4fa 50%, transparent 50%),
    radial-gradient(#d1e4fa 50%, transparent 50%),
    radial-gradient(#d1e4fa 50%, transparent 50%);
  background-size: 4px 4px;
  background-position: 0 0, 100% 0, 0 100%, 100% 100%;
  background-repeat: no-repeat;
  filter: drop-shadow(0 0 6px rgba(209,228,250,.7));
}

/* Static border (left + right cards) */
.ak-cborder {
  position: absolute;
  inset: 0;
  border-radius: 16px;
  border: 1px solid rgba(186,207,247,.12);
  pointer-events: none;
  z-index: 2;
}

/* Animated border (center card only) */
.ak-cring {
  position: absolute;
  inset: 0;
  border-radius: 16px;
  padding: 1px;
  background: conic-gradient(from var(--ak-angle), transparent 0deg, rgba(186,214,247,.5) 36deg, transparent 72deg);
  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  mask-composite: exclude;
  animation: ak-spin 12s linear infinite;
  pointer-events: none;
  z-index: 2;
}
@keyframes ak-spin { to { --ak-angle: 360deg; } }

/* Card content */
.ak-cp {
  position: relative;
  z-index: 4;
  padding: 32px 22px 28px;
  display: flex;
  flex-direction: column;
  gap: 0;
}

.ak-clogo {
  width: 36px; height: 36px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 18px;
  flex-shrink: 0;
}
.ak-clogo-ring {
  background: rgba(186,207,247,.06);
  box-shadow: inset 0 0 0 1px rgba(186,207,247,.12);
}

.ak-cname {
  font-size: 14px;
  font-weight: 500;
  color: rgba(200,212,234,.9);
  margin-bottom: 6px;
  letter-spacing: -0.01em;
}
.ak-csub {
  font-size: 11.5px;
  line-height: 1.55;
  color: rgba(186,207,247,.45);
  margin-bottom: 16px;
}
.ak-clabel {
  font-size: 11.5px;
  font-weight: 500;
  color: rgba(200,212,234,.7);
  margin-bottom: 6px;
  letter-spacing: .01em;
}

.ak-cfield {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: rgba(186,207,247,.06);
  box-shadow: inset 0 0 0 1px rgba(186,207,247,.1);
  border-radius: 8px;
  padding: 9px 12px;
  margin-bottom: 14px;
  min-height: 38px;
}
.ak-cfield-val {
  font-size: 12px;
  color: rgba(200,212,234,.75);
}
.ak-placeholder { color: rgba(200,212,234,.35); }

.ak-cfield-otp {
  justify-content: center;
  letter-spacing: .25em;
  font-size: 16px;
  color: rgba(200,212,234,.7);
}
.ak-ctag {
  font-size: 10px;
  font-weight: 500;
  padding: 2px 7px;
  border-radius: 999px;
  letter-spacing: .02em;
}

.ak-cta {
  width: 100%;
  height: 36px;
  border: none;
  cursor: pointer;
  font-family: inherit;
  font-size: 13px;
  font-weight: 500;
  color: rgba(255,255,255,.9);
  border-radius: 8px;
  transition: opacity .15s;
}
.ak-cta:hover { opacity: .85; }
.ak-cta-pill { border-radius: 999px; background: rgba(186,207,247,.15); }

/* ── CARD POSITIONS ── */

/* Before intro (default) */
.ak-cl {
  margin-right: -52px;
  z-index: 0;
  opacity: 0;
  transform: translateX(260px) translateY(28px) scale(.88);
}
.ak-cc {
  z-index: 2;
  opacity: 0;
  transform: translateY(80px);
}
.ak-cr {
  margin-left: -52px;
  z-index: 0;
  opacity: 0;
  transform: translateX(-260px) translateY(28px) scale(.88);
}

/* After intro */
.ak-cards.on .ak-cl {
  opacity: .72;
  transform: translateX(0) translateY(28px) scale(.88);
  transition: transform 1.5s cubic-bezier(.2,0,.2,1) .35s, opacity 1.5s .35s;
}
.ak-cards.on .ak-cc {
  opacity: 1;
  transform: translateY(-8px);
  transition: transform 1.5s cubic-bezier(.2,0,.2,1) .25s, opacity 1.5s .25s;
}
.ak-cards.on .ak-cr {
  opacity: .72;
  transform: translateX(0) translateY(28px) scale(.88);
  transition: transform 1.5s cubic-bezier(.2,0,.2,1) .35s, opacity 1.5s .35s;
}
</style>
